export const HopperRootCssClass = "hop";
export const StyledSystemRootCssClass = "hop-5-3-9";
export const HopperVariablePrefix = "--hop";

export type Theme = "sharegate" | "workleap";
